module.exports = __webpack_public_path__ + "static/16-801959b8e079eb2d641da9891e17fd48.jpg";